(() => {
  const initializeShowcase = (showcase) => {
    if (!showcase || showcase.dataset.scgScrollReady === 'true') return;

    const scroller = showcase.querySelector('[data-scg-scroll-container]');
    const previousButton = showcase.querySelector('[data-scg-scroll-prev]');
    const nextButton = showcase.querySelector('[data-scg-scroll-next]');

    if (!scroller || !previousButton || !nextButton) return;
    showcase.dataset.scgScrollReady = 'true';

    const updateButtons = () => {
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      previousButton.disabled = scroller.scrollLeft <= 4;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 4;
    };

    const scrollProducts = (direction) => {
      const firstCard = scroller.querySelector('.scg-product-card');
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 260;
      const styles = window.getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const amount = Math.max(cardWidth + gap, scroller.clientWidth * 0.78);
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => scrollProducts(-1));
    nextButton.addEventListener('click', () => scrollProducts(1));
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-scg-showcase]').forEach(initializeShowcase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
